const sizeChartBtns = document.querySelectorAll('.size-chart-popup .buttons-wrappers .m-button');
let tables= document.querySelectorAll('.size-chart-popup table')
sizeChartBtns.forEach((item)=>{
    item.addEventListener('click',(e)=>{
        let value = e.target.dataset.type;
        sizeChartBtns.forEach((btn)=> btn.classList.remove('active'));
        e.target.classList.add('active')
        tables.forEach((table)=> table.classList.remove('active'));
        let table =  document.querySelector(`.size-chart-popup table[data-type="${value}"]`);
        if(table){
            table.classList.add('active');
        }
    })
})

const sizeChart = document.querySelector('.size-chart-popup')
const sizeChartCloseBtns = document.querySelectorAll('.close-size-chart');
sizeChartCloseBtns.forEach((item)=>{
    item.addEventListener('click',(e)=>{
        if(sizeChart){
            sizeChart.classList.remove('active')
        }
    })
})

const sizeChartopenBtns = document.querySelectorAll('.size-chart-open-btn');
sizeChartopenBtns.forEach((item)=>{
    item.addEventListener('click',(e)=>{
        if(sizeChart){
            sizeChart.classList.add('active')
        }
    })
})

document.querySelector('.foxkit-sizechart-button').addEventListener('click', function() {
    if(sizeChart){
        sizeChart.classList.add('active')
    }
})